
import { GPS_RADIUS_PRESETS } from "@/domain/sites/types";
import styles from "./RadiusPicker.module.css";

interface RadiusPickerProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
}

export function RadiusPicker({ value, onChange }: RadiusPickerProps) {
  return (
    <fieldset className={styles.fieldset} aria-label="GPS check-in radius">
      <legend className={styles.legend}>GPS check-in radius</legend>
      <p className={styles.hint}>How close a cleaner needs to be to check in</p>
      <div className={styles.options} role="radiogroup">
        {GPS_RADIUS_PRESETS.map((preset) => {
          const selected = value === String(preset.value);

          return (
            <button
              key={preset.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`${styles.option} ${selected ? styles.selected : ""}`}
              onClick={() => onChange(String(preset.value))}
            >
              {preset.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
